import {createApp} from 'vue'
import options from './FrivilligjobAside.options'

const el = '.kb-component--frivilligjob-aside'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FrivilligjobAsideDOM)=>{            
            const template = FrivilligjobAsideDOM.innerHTML
            
            options.template = template
            const props = {
                jobId: FrivilligjobAsideDOM.dataset.jobId,
                redirectAfterDeleteUrl: FrivilligjobAsideDOM.dataset.deleteRedirectUrl,
            }

            const component = createApp(options, props).use(Store)
            component.mount(FrivilligjobAsideDOM)
        })
    }
}

